import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  retrieveData: {},
  isLoading: false,
  hasData: false,
  retrieveStatus: {
    status: false,
    message: ""
  },
  error: ""
};
const fetchRetrieveOrderSlice = createSlice({
  name: "retrieveOrder",
  initialState,
  reducers: {
    retrieveOrderRequest: (state, action) => {
      state.isLoading = true;
      state.retrieveStatus.status = false;
      state.error = "";
    },
    retrieveOrderSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.retrieveStatus.status = true;
      state.retrieveData = action.payload;
    },
    retrieveOrderFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload.response.data;
      state.retrieveStatus.status = false;
      state.retrieveData = {};
    },
    resetRetrieveOrder: state => {
      state.isLoading = false;
      state.retrieveData = {};
      state.retrieveStatus.status = false;
      state.hasData = false;
      state.error = "";
    }
  }
});
export const {
  retrieveOrderRequest,
  retrieveOrderSuccess,
  retrieveOrderFailure,
  resetRetrieveOrder
} = fetchRetrieveOrderSlice.actions;
export default fetchRetrieveOrderSlice.reducer;